import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Typography, Box } from '@material-ui/core';
import { Lock as LockIcon } from '@material-ui/icons';

import { useJiraAuthUrl } from './Jira.hooks';
import JiraLoginCodeForm, { JiraLoginCodeFormProps } from './JiraLoginCodeForm';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    text-align: center;
    padding-bottom: 20px;
    .MuiSvgIcon-root {
      font-size: 124px;
    }
  }
  &::before {
    content: '';
    flex: 1 1 35%;
  }
  &::after {
    content: '';
    flex: 1 1 65%;
  }
`;

const StyledAllow = styled.span`
  padding: 6px 8px 5px;
  color: #212121;
  background-color: #ececec;
  border: 1px solid #999;
  border-radius: 2px;
`;

const JiraLogin: React.FC<JiraLoginCodeFormProps> = (
  props: JiraLoginCodeFormProps
) => {
  const { isLoading: codeIsLoading, onSubmit } = props;
  const [
    { data: authUrl, isLoading, error },
    getJiraAuthUrl
  ] = useJiraAuthUrl();
  const { url, authStrategy } = authUrl || {};

  const btnProps = {
    href: url || undefined,
    target: url && authStrategy === 1 ? '_blank' : undefined
  };

  useEffect(() => {
    if (!url) {
      return;
    }

    if (authStrategy === 2) {
      window.location.href = url;
    } else {
      // oauth 1.0
      // open new window/tab
      window.open(
        url,
        '_blank',
        'location=yes,height=480,width=640,scrollbars=no,status=no'
      );
    }
  }, [url, authStrategy]);

  const getUrl = () => getJiraAuthUrl();

  return (
    <Container>
      <div className='content'>
        <Box mb={1}>
          <LockIcon color='disabled' fontSize='inherit' />
        </Box>
        <Box mb={1}>
          <Typography variant='h4'>JIRA Access Required</Typography>
        </Box>
        <Box mb={2}>
          <Typography variant='body1' color='textSecondary'>
            You are not logged in or have not granted Sierra QMS permission to
            access Jira on your behalf.
            <br />
            Please login to use this integration.
          </Typography>
        </Box>

        <Button
          color='primary'
          size='large'
          variant='contained'
          onClick={!url ? getUrl : undefined}
          disabled={Boolean(isLoading || error)}
          {...btnProps}
        >
          Log In to JIRA
        </Button>
        {authStrategy === 1 && (
          <>
            <Box my={3} mb={2}>
              <Typography variant='body1' color='textSecondary'>
                After clicking <StyledAllow>Allow</StyledAllow>, enter the given
                verfication code from the popup window:
              </Typography>
            </Box>
            <JiraLoginCodeForm isLoading={codeIsLoading} onSubmit={onSubmit} />
          </>
        )}
      </div>
    </Container>
  );
};

export default JiraLogin;
